import { documentTabConfig } from 'utils/Client/documents'

const documentTypeRegexString = Object.values(documentTabConfig).map(c => (
  c.path
))
  .filter(p => !!p)
  .join('|')

export const CLIENT_LOGIN = '/client/login/:code'
export const CLIENT_OVERVIEW = '/dashboard'
export const CLIENT_PORTFOLIO = '/portfolio'
export const CLIENT_DOCUMENTS = `/documents/:documentListType(${documentTypeRegexString})`
export const CLIENT_UPLOADER = '/upload'
export const CLIENT_PROFILE_SETTINGS = '/settings/:profileType(login|personal)'



// WEBPACK FOOTER //
// ./src/utils/Client/urlPaths.js